import React from 'react';
import { FaHistory, FaBullseye, FaEye, FaHeart } from 'react-icons/fa';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-header">
          <h1>About Pharmacare</h1>
          <p>Your trusted supplier of quality drugs since 1999</p>
        </div>

        <div className="background-section">
          <div className="section-icon">
            <FaHistory />
          </div>
          <h2>BACKGROUND</h2>
          <p>
            We were established on 1st August in 1999 by a group of shareholders. We are registered 
            under the Registration of Companies Act as a Limited Liability and have five board members. 
            With twenty years of experience in the industry, we have grown over the years to cater for 
            various needs in the market to meet up with demands in the medical field. We have four retail 
            pharmacies countrywide and wholesale department and market a wide range of products. We also 
            provide free medical advice by phone and to walk in clients as a first point of contact.
          </p>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <div className="card-icon">
              <FaBullseye />
            </div>
            <h3>MISSION</h3>
            <div className="divider"></div>
            <p>
              Our mission is to provide excellent and easily accessible medical requirements to all our 
              clients with high quality and affordable products in the most convenient way in order to 
              improve the lives of patients and their caregivers.
            </p>
          </div>

          <div className="about-card">
            <div className="card-icon">
              <FaHeart />
            </div>
            <h3>CORE VALUES</h3>
            <div className="divider"></div>
            <ul className="values-list">
              <li>Belief in transparency</li>
              <li>Honesty & Integrity</li>
              <li>Openness & Responsibility</li>
              <li>Respect for Human and Animal Rights</li>
              <li>Compliance with the laws governing the industry</li>
              <li>Passion for human and animal life</li>
              <li>Support for the environment</li>
              <li>Strife for excellence through team work</li>
              <li>Determination</li>
              <li>An Equal Opportunity Employer</li>
            </ul>
          </div>

          <div className="about-card">
            <div className="card-icon">
              <FaEye />
            </div>
            <h3>VISION</h3>
            <div className="divider"></div>
            <p>
              Pharmacare Pharmacies aspires to be the most preferred and leading pharmacy in both retail 
              and wholesale supplies of pharmaceutical and medical products in Malawi.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
